/**
 * Strips subresources (e.g. images, scripts, css, frames) from an HTML string using regex
 * without altering the DOM structure or removing any text.
 * This is to prevent additional network requests when rendering the HTML string.
 *
 * @method stripSubresources
 * @param {string} htmlString - HTML string
 * @returns {string} - HTML string with subresources stripped
 */
const stripSubresources = (htmlString) => {
  // Match individual tags with their attributes
  const tagPattern = /<([a-zA-Z][a-zA-Z0-9]*)((?:\s+[^>]*)?)>/g;

  // Pattern to match specific attributes we want to remove
  const networkAttributes =
    /\s+(src|href|action|data-src|data-href|data-action)\s*=\s*(['"])[^'"]*\2/gi;

  htmlString = htmlString.replace(tagPattern, (match, tagName, attributes) => {
    // If no attributes, return original tag
    if (!attributes) {
      return match;
    }

    // Remove network request attributes
    const cleanedAttributes = attributes.replace(networkAttributes, '');

    // Reconstruct the tag
    return `<${tagName}${cleanedAttributes}>`;
  });

  // Regular expression to match <script> and <style> tags and their content
  const removeInlineScriptsAndStylesRegex =
    /<script\b[^>]*>([\s\S]*?)<\/script>|<style\b[^>]*>([\s\S]*?)<\/style>/gi;

  // Replace matched <script> and <style> tags with an empty string
  htmlString = htmlString.replace(removeInlineScriptsAndStylesRegex, '');

  return htmlString;
};

export default stripSubresources;
